import { useMe } from "@/hooks/useMe.tsx";
import PricingModal from "@/components/PricingModal.tsx";
import { FC, PropsWithChildren } from "react";

export const PaywallWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { me } = useMe({});
  return me?.subscription === false ? <PricingModal /> : children;
};
